/**
 * Enum hành động auditinglog
 */
export default {
    Add : 1, //Thêm
    Delete : 2, //Xóa
    Edit : 3, //Sửa
    Login : 4, //Đăng nhập
    Logout : 5, //Đăng xuất
    Approved : 6, //Phê duyệt
    Public : 7, //Ban hành
    Print : 8, //in báo cáo
    EstimateRevenue : 9, //lập dự toán thu
    EstimateExpenditure : 10, //lập dự toán chi
    SendEstimate : 11, //gửi dự toán cho cấp trên
    Export : 12, //xuất khẩu
    Import : 19, //nhập khẩu
    RequestSendEstimate : 13, //yêu cầu cấp dưới nộp dự toán
    GettingStarted : 14, //getting
    SendBack : 15, //Gửi trả
    ConfirmExamine : 16, //xác nhận hoàn thành kiểm tra
    Used : 17, // Sử dụng
    UnUsed : 18, // Ngừng sử dụng
    FurtherInspect : 20, // Duyệt thêm
    MergeContent : 21, // Gộp nội dung
    Denied : 23, //Từ chối
    Respond : 24, //Gửi phản hồi
    CancelApproved : 25, // Hủy duyệt
    CancelComplete : 26, // Hủy hoàn thành
    Complete : 27, // Hoàn thành
    SubmitEstimate : 28, // Nộp biểu mẫu
    DeliverDecision : 29, // Giao quyết định
    RecoverDecision : 30, // Thu hồi quyết định
    RefreshPublishTemplate : 31, // Lấy lại mẫu cấp trên ban hành (Biểu ban hành)
    Sync : 32, // Đồng bộ mẫu cấp trên
    SyncPublishExplanationForm : 33, // Đồng bộ biểu cấp trên ban hành (Biểu ban hành)
    GetBeforeData : 34, // Lấy dữ liệu năm trước

    DeleteMassData : 44, // Xóa dữ liệu hàng loạt

    LoginFailed : 101, //Đăng nhập thất bại
    CreatedUser : 102, //Tạo người dùng
    EditUser : 103, //Sửa người dùng
    DeleteUser : 104, //Xóa người dùng
    PermissionUser : 105, //Phân quyền người dùng
    CreatedRoles : 106, //Tạo quyền
    EditRoles : 107, //Sửa quyền
    DeleteRoles : 108, //Xóa quyền

    CreatedDatabase : 120, //Tạo cơ sở dữ liệu
    EditDatabase : 121, //Sửa cơ sở dữ liệu
    DeleteDatabase : 122, //Xóa cơ sở dữ liệu

    CreatedTennant : 130, //Tạo khách hàng
    DeleteTennant : 132, //Xóa khách hàng
};
  